import { createSlice } from '@reduxjs/toolkit'
import queryString from 'query-string'
// import axios from '../../api/index'
import api from '../../api/index'
import {
  failed,
  // success,
  // info
} from './snackSlice'
import { startLoading, stopLoading } from './loadingSlice'

export const customersSlice = createSlice({
  name: 'customers',
  initialState: { list: [] },
  reducers: {
    customersFetched: (state, { payload }) => (
      { ...state, list: payload.data, total: payload.totalHits }
    ),
  },
})

export default customersSlice.reducer

export const {
  customersFetched,
} = customersSlice.actions

export const getCustomers = (data) => (dispatch) => {
  const params = queryString.stringify(data, { arrayFormat: 'index' })
  dispatch(startLoading())
  api.get('account/user/profile', { params: new URLSearchParams(params) })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(customersFetched(res?.data))
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message, ''))
      dispatch(failed('مشکل در دریافت فهرست اعضا'))
    })
}
